import React from 'react';
import {
  AppBar,
  Box,
  Grid,
  Tab,
  Tabs,
  Typography
} from '@material-ui/core';
import { useRouter } from 'next/router';
import { default as MainContent } from '../PortalHome';
import { AgentLayout as Layout } from '../../../components/Portal';
import AppContext from "../../../components/AppContext";
import { fetcher } from '../../../components/Auth/AuthProvider';
import { serverUrl } from "../../../server/constants";
import Allianz from "../../../components/EnrollmentForms/Allianz";
import NationalLifeGroup from "../../../components/EnrollmentForms/NationalLifeGroup";
import MinnesotaLife from "../../../components/EnrollmentForms/MinnesotaLife";
import Annexus from "../../../components/EnrollmentForms/Annexus";
import Carriers from "../../../components/Carriers";
import { SampleIllustrations } from '../../../components/SampleIllustrations';
import { Paths } from '../../../utils/enums';

export async function getServerSideProps(context: any) {
  const carrier = context.params.carrier;
  try {
    const res = await fetch(serverUrl + '/api/pages/' + carrier);
    const page: any = await res.json();
    return {
      props: {
        page: page,
        data: JSON.parse(page.content),
        keyword: page.keywords,
        title: page.title,
        description: page.description
      }
    };
  } catch (err: any) {
    return {
      props: {
        page: {},
        data: {},
        errors: err.message
      }
    };
  }
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}


function TabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Carrier = (props:any) => {
  const router = useRouter();
  const {asPath, push, query, replace} = router;
  const [value, setValue] = React.useState(0);

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    let redir = '';
    switch (newValue) {
      case 0:
        redir = Paths.AgentPortalEnrollmentSample;
        break;
      case 1:
        redir = Paths.AgentPortalEnrollmentAllianz;
        break;
    }
    return replace(redir);
  };

  const renderSwitch = (carrier: any) => {
    switch(carrier) {
      case 'allianz':
        return <Allianz carrierData={props.data} />;
      case 'annexus':
        return <Annexus carrierData={props.data} />;
      case 'minnesota-life':
        return <MinnesotaLife carrierData={props.data} />;
      case 'national-life':
        return <NationalLifeGroup carrierData={props.data} />;
      default:
        return <>Unknown Carrier</>;
    }
  };

  React.useEffect(() => {
    fetcher()
      .then((authUser) => {
        if (!authUser) {
          return push(Paths.Home);
        }
      });
  }, []);

  return (
    <AppContext.Provider value={props.page}>
      <Layout>
        <MainContent
          title="Illustrations & Enrollment"
          description="Resources to ensure your success selling NIW products and services."
        >
          <Grid item xs={12} md={12} lg={12}>
            <AppBar color="default" position="static">
              <Tabs
                value={value} onChange={handleChange} indicatorColor="primary" textColor="primary" variant="fullWidth"
              >
                <Tab label="Sample Illustrations" {...a11yProps(0)} />
                <Tab label="Enrollment Forms" {...a11yProps(1)} />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              <SampleIllustrations />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Carriers path={asPath} directory={Paths.AgentPortalEnrollmentDir}/>
              {
                renderSwitch(query.carrier)
              }
            </TabPanel>
          </Grid>
        </MainContent>
      </Layout>
    </AppContext.Provider>
  );
}

export default Carrier
